import {
  AmplifyGet,
  AmplifyPost,
} from "@sunrun/sales-experience-shared/amplify-api-wrapper";
import { type ContractReviewResponse } from "../../amplify/backend/function/OfferExpCheckout/ts/public/types";
import { logger } from "providers/logger";

const CONTRACT_REVIEW_STARTED_RESPONSE: ContractReviewResponse = {
  result: "started",
  statusCode: 200,
  messages: [],
};

const getHttpStatusCode = (err: unknown): number | undefined =>
  (err as { response?: { statusCode?: number } })?.response?.statusCode;

const getContractReview = async (
  authKey: string,
  proposalId: string
): Promise<ContractReviewResponse> => {
  return await AmplifyGet<ContractReviewResponse>(
    "Get Contract Review",
    "OfferExpApi",
    `/contract-review?proposal=${proposalId}`,
    {
      headers: {
        Authorization: `Bearer ${authKey}`,
      },
    },
    logger,
    {
      expectedErrorCodes: [404],
    }
  );
};

const startContractReview = async (
  authKey: string,
  proposalId: string
): Promise<ContractReviewResponse> => {
  try {
    return await AmplifyPost<ContractReviewResponse>(
      "Start Contract Review",
      "OfferExpApi",
      `/contract-review`,
      {
        headers: {
          Authorization: `Bearer ${authKey}`,
        },
        body: { proposal: proposalId },
      },
      logger,
      {
        expectedErrorCodes: [502],
      }
    );
  } catch (err) {
    if (getHttpStatusCode(err) === 502) {
      return CONTRACT_REVIEW_STARTED_RESPONSE;
    }
    throw err;
  }
};

export {
  CONTRACT_REVIEW_STARTED_RESPONSE,
  getContractReview,
  startContractReview,
};
